import { Directive, ElementRef, AfterViewInit, OnDestroy, NgZone, HostListener } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
    selector: '[equalHeight]',
    standalone: true
})
export class EqualHeightDirective implements AfterViewInit, OnDestroy {

    private destroy$ = new Subject<void>();

    constructor (
        private el: ElementRef<HTMLElement>,
        private zone: NgZone
    ) { }

    ngAfterViewInit (): void {
        this.equalizeHeights();
    }

    @HostListener('window:resize')
    onResize (): void {
        this.equalizeHeights();
    }

    ngOnDestroy (): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public equalizeHeights (): void {
        const container = this.el.nativeElement;
        const targets = container.querySelectorAll('[data-equal="card-box"]');

        if (!targets || targets.length === 0) return;

        targets.forEach((el: HTMLElement) => {
            el.style.height = 'auto';
        });

        requestAnimationFrame(() => {
            let maxHeight = 0;

            targets.forEach((el: HTMLElement) => {
                if (el.offsetHeight > maxHeight) {
                    maxHeight = el.offsetHeight;
                }
            });

            targets.forEach((el: HTMLElement) => {
                el.style.height = `${maxHeight}px`;
            });
        });
    }
}
